import { parse, serialize } from "cookie";

const CITY_COOKIE_KEY = "city-slug";

type CookieOptions = {
  domain?: string;
  path?: string;
  maxAge?: number;
};

export const getCitySlugCookie = (): string | undefined => {
  if (typeof document === "undefined") return undefined;

  const cookies = parse(document.cookie || "");
  return cookies[CITY_COOKIE_KEY];
};

export const setCitySlugCookie = (
  value: string,
  options?: CookieOptions,
): void => {
  if (typeof document === "undefined") return;

  const serialized = serialize(CITY_COOKIE_KEY, value, {
    path: options?.path ?? "/",
    domain: options?.domain,
    maxAge: options?.maxAge ?? 60 * 60 * 24 * 7,
  });

  document.cookie = serialized;
};

export const removeCitySlugCookie = (options?: CookieOptions): void => {
  if (typeof document === "undefined") return;

  const serialized = serialize(CITY_COOKIE_KEY, "", {
    path: options?.path ?? "/",
    domain: options?.domain,
    maxAge: 0,
  });

  document.cookie = serialized;
};
